<template>
  <div>
    <div class="logo-wrapper">
      <img @click="goHome" style="cursor: pointer" src="@/src/assets/img/img_logo.png" alt="logo">
    </div>
    <el-menu router>
      <el-sub-menu v-for="(menu, i) in menuList" :index="`${menu.path}`" :key="`menu-${i}-${menu.path}`">
        <template #title>
          <div class="menu-parent">
            <el-icon>
              <component :is="menu.icon"/>
            </el-icon>
            {{ menu.label }}
          </div>
        </template>
        <el-menu-item-group>
          <el-menu-item v-for="(item, j) in menu.itemList" class="menu-child" :index="`${menu.path}${item.path}`"
                        :key="`menu-${i}-${j}-${menu.path}-${item.path}`">
            {{ item.label }}
          </el-menu-item>
        </el-menu-item-group>
      </el-sub-menu>
    </el-menu>
  </div>
</template>

<script setup lang="ts">
import {computed} from "vue";
import {useRouter} from "vue-router";

const router = useRouter();

const goHome = () => {
  router.push("/");
};

const menuList = computed(() => {
      return [
        {
          path: "/meal-plan",
          label: "식단 관리",
          icon: "Food",
          itemList: [
            {
              path: "/baby",
              label: "이유식 식단",
            },
            {
              path: "/others",
              label: "반찬국 식단",
            },
            {
              path: "/set",
              label: "프로모션 식단",
            },
            {
              path: "/excel",
              label: "엑셀 데이터 관리",
            },
          ],
        },
        {
          path: "/product",
          label: "상품 관리",
          icon: "Goods",
          itemList: [
            {
              path: "/",
              label: "상품 관리"
            },
            {
              path: "/allergy",
              label: "알레르기 관리"
            },
            {
              path: "/ingredient",
              label: "원재료 관리"
            },
          ]
        },
        {
          path: "/order",
          label: "주문 관리",
          icon: "Grid",
          itemList: [
            {
              path: "",
              label: "DPS 엑셀 출력"
            },
            {
              path: "/mes",
              label: "MES 주문 연동"
            },
            {
              path: "/update/meal",
              label: "정기 주문 식단 변경"
            },
            {
              path: "/production/output",
              label: "생산량 내역 출력"
            },
          ]
        },

        {
          path: "/shipping",
          label: "배송 관리",
          icon: "Van",
          itemList: [
            {
              path: "/holiday",
              label: "배송 휴일 관리",
            },
            {
              path: "/block-area",
              label: "배송 불가 지역 관리",
            },
            {
              path: "/dawn-area",
              label: "새벽 배송 지역 관리",
            },
            {
              path: "/fee-group",
              label: "배송비 그룹 관리",
            },
          ],
        },
        {
          path: "/customer-group",
          label: "회원 그룹 관리",
          icon: "Medal",
          itemList: [
            {
              path: "",
              label: "회원 그룹 관리"
            }
          ],
        },
      ]
    }
);

</script>

<style lang="scss" scoped>
.logo-wrapper {
  padding: 4rem;

  img {
    display: block;
    width: 100%;
  }


  .logout-wrapper {
    margin-top: 1rem;
  }
}

.el-menu {
  .menu-child {
    padding-left: 80px !important;
  }

  .menu-parent {
    font-size: 1.6rem;

    .el-icon {
      margin-right: 1rem;

      svg {
        width: 2rem;
        height: 2rem;
      }
    }
  }
}
</style>
<style lang="scss">
.el-menu-item-group__title {
  padding: 0 !important;
}

.el-sub-menu {
  margin-bottom: 8px !important;
}
</style>
